import i18n from './i18n/config';
import { syncDocumentLanguage } from './i18n/syncDocumentLanguage';

syncDocumentLanguage(i18n);
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-mono/400.css';

import posthog from 'posthog-js';
import { StrictMode } from 'react';
import config from '@/config/config';

if (config.POSTHOG_KEY) {
	posthog.init(config.POSTHOG_KEY, {
		api_host: config.POSTHOG_HOST,
		capture_pageview: false,
	});
}
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { PostHogProvider } from '@/providers/PostHogProvider';
import './globals.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: 1,
		},
	},
});

export interface RouterContext {
	queryClient: QueryClient;
}

const router = createRouter({ routeTree, context: { queryClient } });

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
	<StrictMode>
		<PostHogProvider>
			<QueryClientProvider client={queryClient}>
				<RouterProvider router={router} />
			</QueryClientProvider>
		</PostHogProvider>
	</StrictMode>,
);
